import { GateResponseDto } from '@planning/app/api'
import { EventTypes } from '@planning/messages/eventsTypes'
import { GetGatesQuery } from '@planning/messages/queries/getGatesQueryHandler'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import _ from 'lodash'
import { action, computed, makeObservable } from 'mobx'
import { EntityItem } from '../base/EntityItem'
import { ItemStore } from '../base/ItemStore'
import { IEntityStore } from '../types'

export class GateItem extends EntityItem<GateResponseDto, string> {}

export class GateItemStore
  extends ItemStore<GateResponseDto, GateItem, string>
  implements IEntityStore<GateItem>
{
  private hasBeenLoaded = false

  constructor(private messageBus: IMessageBus) {
    super((key, data) => new GateItem(key, data))
    makeObservable(this, {
      activeGates: computed,
      receiveQuery: action,
      receiveUpsertedEvent: action,
      receiveDeletedEvent: action,
    })

    messageBus.subscribeEvent(GetGatesQuery.type, this.receiveQuery)
    messageBus.subscribeEvent(EventTypes.GateUpsertedEvent, this.receiveUpsertedEvent)
    messageBus.subscribeEvent(EventTypes.GateDeletedEvent, this.receiveDeletedEvent)
  }

  fetch = async () => {
    if (this.hasBeenLoaded) return
    this.hasBeenLoaded = true
    await this.messageBus.dispatchQuery(new GetGatesQuery())
  }

  get activeGates() {
    return _(this.elements)
      .map(item => item.data)
      .filter(item => item.active === true)
      .orderBy([item => item.code, item => item.name])
      .value()
  }

  receiveQuery = (event: IEvent<GateResponseDto[]>): void => {
    if (event.payload) {
      this.upsertBulk(event.payload)
    }
  }

  // Deactivation arrives as an upsert with active === false; the gate stays in the
  // element map but is filtered out of activeGates.
  receiveUpsertedEvent = (event: IEvent<GateResponseDto>) => {
    if (event.payload) {
      this.upsert(event.payload)
    }
  }

  receiveDeletedEvent = (event: IEvent<string>): void => {
    if (event.payload) {
      this.delete(event.payload)
    }
  }
}
